module.exports = __webpack_public_path__ + "resource/img/menu.b70cb32f.svg";